import { axiosInstance } from "@/lib/axios-instance";

interface getMembersResponse {
  status: string;
  opp_judges: {
    _id: string;
    onboarding_status: {
      deals_page: boolean;
      deals_popup: boolean;
    };
    user_type: string;
    country: string;
    isVerified: boolean;
    created_a_company_once: boolean;
    receive_follow_up_registration_email: boolean;
    status: string;
    first_name: string;
    last_name: string;
    email: string;
    sub_vertical: string;
    role?: string; // Add role field from affiliation
    type?: string; // Add type field from API response
    clerk_primary_email?: string | null;
    clerk_emails?: string[];
    created_on: string;
    __v: number;
    reviews: {
      _id: string;
      created_on: string;
      __v: number;
    }[];
  }[];
}

interface createJudgeRequest {
  first_name: string;
  last_name: string;
  email: string;
  sub_vertical: string;
}

interface createJudgeResponse {
  status: string;
  data?: {
    onboarding_status: {
      deals_page: boolean;
      deals_popup: boolean;
    };
    user_type: string;
    country: string;
    isVerified: boolean;
    created_a_company_once: boolean;
    receive_follow_up_registration_email: boolean;
    status: string;
    _id: string;
    first_name: string;
    last_name: string;
    email: string;
    sub_vertical: string;
    created_on: string;
    __v: number;
  };
  message?: string;
}

interface createAffiliationRequest {
  user?: string;
  opportunity: string;
  status: string;
  email?: string;
  role?: string; // Add role field
}

interface createAffiliationResponse {
  status: string;
}

interface deleteJudgeResponse {
  status: string;
}

export const teamApi = {
  getTeamMembers: async (workspaceId: string) => {
    const response = await axiosInstance.get<getMembersResponse>(
      "/fetch_judges_for_opportunity_simple",
      {
        params: {
          opportunity_id: workspaceId,
        },
      }
    );
    return response.data;
  },
  createJudge: async (judge: createJudgeRequest) => {
    const response = await axiosInstance.post<createJudgeResponse>(
      "/admin_create_judge",
      judge
    );
    return response.data;
  },
  createAffiliation: async (affiliation: createAffiliationRequest) => {
    const response = await axiosInstance.post<createAffiliationResponse>(
      "/create_judge_opportunity_affiliation",
      affiliation
    );
    return response.data;
  },
  deleteJudge: async (judgeId: string, workspaceId: string) => {
    const response = await axiosInstance.post<deleteJudgeResponse>(
      `/delete_judge_from_opportunity`,
      {
        judge_id: judgeId,
      },
      {
        params: {
          opportunity_id: workspaceId,
        },
      }
    );
    return response.data;
  },
};
